module.exports = __webpack_public_path__ + "img/jyxd.503db0f4.jpg";